module.exports = __webpack_public_path__ + "img/img-gzt-1.1ca89914.png";